<ng-container *ngIf="notifications.notifications() | async as lookatme">
   <button mat-icon-button class="common-m005em">
      <mat-icon [matBadge]="lookatme.length">notifications</mat-icon>
   </button>
</ng-container>
